import React, { FC, Fragment } from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";
import { useFormModel } from "../core/FormModelHelpes";
import { ChangeNames } from "../../clients/FirebaseClient/types";

const useFormControlStyle = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        formControlLabelCheckboxStyle: {
            width: 300,
        },
        checkboxStyle: {
            marginRight: 8,
        },
    }),
);

export const ChargerPersonalContributionUndergroundWorkForm: FC = () => {
    const { values, setValues } = useFormModel<
        ChangeNames.CHARGER_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK
    >();

    const formControlClasses = useFormControlStyle();

    return (
        <Fragment>
            <FormControlLabel
                isCheckBox={true}
                className={formControlClasses.formControlLabelCheckboxStyle}
                control={
                    <Checkbox
                        className={formControlClasses.checkboxStyle}
                        value="PersonalContributionCanDoUndergroundWork"
                        checked={
                            values.chargerPersonalContributionCanDoUndergroundWork?.value?.yes
                        }
                        onChange={(event, checked) =>
                            setValues(values => {
                                if (checked) {
                                    values.chargerPersonalContributionCanDoUndergroundWork = {
                                        value: {
                                            yes: true,
                                            no: false,
                                        }
                                    }
                                } else {
                                    values.chargerPersonalContributionCanDoUndergroundWork = {
                                        value: {
                                            yes: false,
                                            no: true,
                                        }
                                    }
                                }
                            })
                        }
                    />
                }
                label="Tiefbau"
                sublabel="Der Tiefbau auf dem Kundengrundstück <b>kann</b> in Eigenleistung ausgeführt werden."
                text="Die Mindestanforderungen für die Erbringung von Eigenleistungen können Sie <a href='https://www.syna.de/content/dam/syna-de/dokumente/netzanschluss/weg-zum-netzanschluss/eigenleistungen-mindestanforderungen-syna-012015.pdf'>hier</a> als PDF Dokument herunterladen."
                error={!!values.chargerPersonalContributionCanDoUndergroundWork.error}
            />
        </Fragment>
    );
};
